module.exports = __webpack_public_path__ + "static/media/dodawanie_w_zakresie_30_rozpisywanie.a6f0bd52.pdf";